import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LoadingSkeletonDirective2 } from 'common-ui';
import { ProductId, productIdentifierAttribute } from 'products-data';

@Component({
  selector: 'ideal-product-id-label',
  imports: [LoadingSkeletonDirective2],
  templateUrl: './product-id-label.component.html',
  styleUrl: './product-id-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.show-labels]': 'showLabels()',
  },
})
export class ProductIdLabelComponent {
  public readonly productId = input<ProductId | null, ProductId | string | undefined | null>(null, {
    transform: productIdentifierAttribute,
  });

  public readonly showLabels = input(false, {
    transform: booleanAttribute,
  });
  public readonly isLoading = computed(() => !this.productId());
}
